import { render } from "./chat.vue?vue&type=template&id=2ecf3492"
import script from "./chat.js?vue&type=script&lang=js"
export * from "./chat.js?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=2ecf3492&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__